

<!-- Edit Panel Code  -->
 @if(brokerMappingService.isEdit){
<p-drawer id="sidebar_brokermapping_view" styleClass="u ui-sidebar-lg"
  [style]="{ 'width': 'auto', 'max-width': '580px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%'}"
  [(visible)]="brokerMappingService.isEdit" position="right" [baseZIndex]="10000" (onHide)="onClose()">

  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div>
      <h3 class="ui-grid-col-12">Edit Broker Details </h3>
      @for (col of columns; track col;){
      <div class="ui-grid-col-12">
        @if(col?.header!='Action'){
        <span>
          <div class="ui-grid-col-5 quick-view-grid-row">
            <label for="colHeader">{{col.header}}</label>
          </div>
          @if(col?.dropdown !== 'YES'){
          <div class="ui-grid-col-7 quick-view-grid-row">
            @if(col?.dropdown !== 'YES'){
            <input [maxlength]="col?.maxlength" [disabled]="col?.disabled" pInputText [id]="col?.field" [(ngModel)]="this.brokerMappingService.editRow[col.field]" />
            }
          </div>}
          @if(col?.dropdown == 'YES'){
          <div class="ui-grid-col-7 quick-view-grid-row">
            <p-select required name="affiliateFlagdropdon" [id]="col?.field" id="affiliateFlagdropdown"
              [options]="brokerMappingService.affiliateFlag" [(ngModel)]="this.brokerMappingService.editRow[col.field]"
              [style]="{ 'text-transform': 'capitalize', 'width':'58%'}" [placeholder]="this.brokerMappingService.editRow[col.field]">
              <ng-template let-filterCols pTemplate="item">
                <div class="ui-helper-clearfix">
                  <div [id]="filterCols.label" [matTooltip]="filterCols?.description" [matTooltipShowDelay]="1000"
                    matTooltipPosition="after">
                    {{filterCols?.label}}</div>
                </div>
              </ng-template>
            </p-select>
          </div>}
        </span>}
      </div>}
      <div class="ui-grid-col-12">
        <button id="saveEditBrokerMapping" pButton type="button" (click)="onSave()"
          class="ui-button-info ui-grid-col-1 btn-style pull-right userActionBtn" label="Save"></button>
        <button id="closeEditBrokerMapping" pButton type="button" (click)="onClose()"
          class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionBtn" label="Close"></button>
      </div>
    </div>
  </div>
</p-drawer>}